import { Directive, ViewContainerRef, TemplateRef, Input, NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class NgxLetDirective {
    /**
     * @param {?} _viewContainer
     * @param {?} _templateRef
     */
    constructor(_viewContainer, _templateRef) {
        this._viewContainer = _viewContainer;
        this._templateRef = _templateRef;
        this._context = new NgxLetContext();
    }
    /**
     * The expression to be stored as local value and used for showing a template.
     * @param {?} value
     * @return {?}
     */
    set let(value) {
        this._context.let = value;
        this._viewContainer.clear();
        if (this._templateRef) {
            this._viewContainer.createEmbeddedView(this._templateRef, this._context);
        }
    }
}
NgxLetDirective.ɵfac = function NgxLetDirective_Factory(t) { return new (t || NgxLetDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
NgxLetDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NgxLetDirective, selectors: [["", "let", ""]], inputs: { let: "let" } });
/** @nocollapse */
NgxLetDirective.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: TemplateRef }
];
NgxLetDirective.propDecorators = {
    let: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxLetDirective, [{
        type: Directive,
        args: [{ selector: '[let]' }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.TemplateRef }]; }, { let: [{
            type: Input
        }] }); })();
class NgxLetContext {
    constructor() {
        this.let = null;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxLetDirectiveModule {
}
NgxLetDirectiveModule.ɵfac = function NgxLetDirectiveModule_Factory(t) { return new (t || NgxLetDirectiveModule)(); };
NgxLetDirectiveModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxLetDirectiveModule });
NgxLetDirectiveModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxLetDirectiveModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [
                    NgxLetDirective,
                ],
                exports: [
                    NgxLetDirective,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxLetDirectiveModule, { declarations: [NgxLetDirective], exports: [NgxLetDirective] }); })();

export { NgxLetContext, NgxLetDirective, NgxLetDirectiveModule };

